import React from 'react';
import { useLanguage } from '../LanguageContext';

// Shown when a data fetch fails (network / 5xx) instead of rendering an empty
// screen. Keeps "request failed" visually distinct from "no data" and "loading"
// so a transient server blip (e.g. a deploy restart) never looks like lost data.
export default function LoadError({ onRetry }) {
  const { t } = useLanguage();
  return (
    <div style={{ textAlign: 'center', padding: 60 }}>
      <div style={{ fontSize: '2rem', marginBottom: 12, opacity: 0.5 }}>{'⚠️'}</div>
      <div style={{ color: 'var(--text-primary)', fontWeight: 600, marginBottom: 4 }}>{t('loadError')}</div>
      <div style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: 16 }}>{t('loadErrorHint')}</div>
      {onRetry && (
        <button className="btn btn-secondary btn-sm" onClick={onRetry}>{t('retry')}</button>
      )}
    </div>
  );
}
